import { Component, inject, OnInit } from '@angular/core';
import { AuthService, SavedCartConfigService } from 'gung-standard';
import { first, forkJoin, map } from 'rxjs';
import {
  CheckoutSettingsGroup,
  HlDisplayPortalFeaturesService,
  OpenOrdersSettingsGroup
} from '../../services/hl-display-portal-features.service';

@Component({
  selector: 'app-hl-display-open-orders-quotes',
  template: `
    <lib-gung-tabset justify="fill">
      <lib-gung-tab [title]="'ORDER_UPLOAD' | translate" *ngIf="isCustomerService || allowImportForUsers">
        <ng-template libGungTabContent>
          <div class="pb-4"></div>
          <hl-display-import-linesheet></hl-display-import-linesheet>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'ORDERS' | translate">
        <ng-template libGungTabContent>
          <div class="pb-4"></div>
          <app-hl-display-open-orders></app-hl-display-open-orders>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'INVOICES' | translate" *ngIf="showInvoiceTab && isSales">
        <ng-template libGungTabContent>
          <div class="pb-4"></div>
          <app-hl-display-invoices></app-hl-display-invoices>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'OFFERS' | translate" *ngIf="showOffersTab && !isManager">
        <ng-template libGungTabContent>
          <div class="pb-4"></div>
          <app-hl-display-quotes></app-hl-display-quotes>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'QUOTATIONS' | translate" *ngIf="showSavedQuotes && (isSales || isCustomerService)">
        <ng-template libGungTabContent>
          <div class="pb-4"></div>
            <lib-filter-list [configService]="savedCartConfigService"></lib-filter-list>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'MEETINGS' | translate" *ngIf="showMeetingsTab && !isManager">
        <ng-template libGungTabContent>
          <div class="pb-4"></div>
          <app-hl-display-meetings></app-hl-display-meetings>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  `,
  styleUrls: ['./hl-display-open-orders-quotes.component.css'],
  standalone: false
})
export class HlDisplayOpenOrdersQuotesComponent implements OnInit {
  public isManager = false;
  isSales = false;
  isCustomerService = false;

  showInvoiceTab = false;
  showMeetingsTab = false;
  showOffersTab = false;
  showSavedQuotes = false;
  allowImportForUsers = false;

  public savedCartConfigService = inject(SavedCartConfigService);

  constructor(
    protected authService: AuthService,
    protected hlDisplayPortalFeaturesService: HlDisplayPortalFeaturesService
  ) { }

  ngOnInit() {
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isManager = roles.includes('MANAGER');
        this.isSales = roles.includes('SALES');
        this.isCustomerService = roles.includes('CUSTOMER_SERVICE');
      });
    forkJoin({
      openOrdersSettingsGroup: this.hlDisplayPortalFeaturesService
        .getPortalFeatureGroup('openOrdersSettingsGroup')
        .pipe(
          first(),
          map(openOrdersSettings => openOrdersSettings as OpenOrdersSettingsGroup)
        ),
      checkoutSettingsGroup: this.hlDisplayPortalFeaturesService
        .getPortalFeatureGroup('orderCheckoutSettingsGroup')
        .pipe(
          first(),
          map(checkoutSettings => checkoutSettings as CheckoutSettingsGroup)
        )
    }).subscribe(({ openOrdersSettingsGroup, checkoutSettingsGroup }) => {
      this.showInvoiceTab = openOrdersSettingsGroup.showInvoiceTab;
      this.showMeetingsTab = openOrdersSettingsGroup.showMeetingsTab;
      this.showOffersTab = openOrdersSettingsGroup.showOffersTab;
      this.allowImportForUsers = openOrdersSettingsGroup.allowImportForUsers;
      this.showSavedQuotes = checkoutSettingsGroup.showSavedQuotes;
    });
  }
}
